
import Tracks from "src/views/tracks/CreateTrackView";
import PodCastEdit from "src/views/podcast/PodCastEdit";
import PodCastList from "src/views/podcast/PodCastList";
import PodCastView from "src/views/podcast/PodCastView";
import DiscoverView from "src/views/discovery/DiscoveryView"
import PlanView from "src/views/credits/Plan";
import Credits from "src/views/credits/Credits";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance"
import TrackView from "src/views/tracks/TrackView";
// @material-ui/icons
import TrackIcon from "@material-ui/icons/Add"
import SignOutIcon from "@material-ui/icons/LockOpen";
import Mic from "@material-ui/icons/Mic";
import CreditIcon from "@material-ui/icons/AccountBalanceWallet"
import DiscoverIcon from  "../custom_components/DiscoverIcon"
import * as types from '../types'
import ValidateAndPurchase from "src/views/tracks/ValidateAndPurchase";


export default [
 
  {
    hidden:true,
    path: types.ViewState.getDefaultHash(types.AppSection.NewTrack)+"?podcast_id=:podcast_id",
    name: "New Track",
    icon: TrackIcon,
    component: Tracks
  },
  {
    hidden:true,
    path: types.ViewState.getDefaultHash(types.AppSection.NewTrack),
    name: "New Track",
    icon: TrackIcon,
    component: Tracks
  },
  {
 
    path: types.ViewState.getDefaultHash(types.AppSection.Discovery),
    name: "Discover",
    icon: DiscoverIcon,
    component: DiscoverView
  },
  {
    path: types.ViewState.getDefaultHash(types.AppSection.TrackValidate)+'/:request_id',
    name: "Validate and Process",
    icon: TrackIcon,
    component: ValidateAndPurchase,
    hidden:true,
  },
 
  {
    hidden:true,
    path: types.ViewState.getDefaultHash(types.AppSection.PodCast)+'/:id/edit',
    name: "Podcasts",
    icon: TrackIcon,
    component: PodCastEdit
  },
  {
    hidden:true,
    path: types.ViewState.getDefaultHash(types.AppSection.PodCast)+'/:id',
    name: "Podcasts",
    icon: Mic,
    component: PodCastView
  },
  {
    path: types.ViewState.getDefaultHash(types.AppSection.PodCast),
    name: "Podcasts",
    icon: Mic,
    component: PodCastList
  },
  {
    path: types.ViewState.getDefaultHash(types.AppSection.Plan),
    name: "Account",
    icon: AccountBalanceIcon,
    component: PlanView
  },
  {
    hidden:true,
    path: types.ViewState.getDefaultHash(types.AppSection.Credits),
    name: "Credits",
    icon: CreditIcon,
    component: Credits
  },
  {
    path: types.ViewState.getDefaultHash(types.AppSection.LogOut),
    name: "Logout",
    icon: SignOutIcon,
    component: Credits
  },
{ redirect: true, path: "/views", pathTo: "/views/podcast", name: "Podcast" }
];




// WEBPACK FOOTER //
// ./src/routes/dashboard.tsx